import {CSSProperties, useState} from "react";
import {Form, Modal} from "semantic-ui-react";
import { useAppDispatch } from "../../app/hooks";
import { Signup } from "./AuthActions";
import { useTranslation } from "react-i18next";
interface Props {
  show: boolean;
  onHide: () => void;
  showLogin: () => void;
}
const Register = ({show, onHide, showLogin}: Props) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();
  const {t} = useTranslation();
  const [fields, setFields] = useState<any>({company: "", email: "", password: "", repeatpass: ""});
  const [errors, setErrors] = useState<any>({company: "", email: "", password: "", repeatpass: ""}); // {email: "Įveskite galiojantį el. pašto adresą", password: "Slaptažodis turi būti ilgesnis nei 6 simboliai", repeatpass: t("passwords_not_match")}
  const handleShowLogin = () => {
    closeForm();
    showLogin();
  };
  const handleInputChange = (e: any) => {
    setErrors({...errors, [e.target.name]: ""});
    setFields({...fields, [e.target.name]: e.target.value});
  };
  const validateForm = () => {
    let temp: any = {...errors};
    temp.company = fields.company ? "" : t("insert_company_name");

    if (!fields.email) {
      temp.email = t("enter_email");
    } else if (!/\S+@\S+\.\S+/.test(fields.email)) {
      temp.email = t("enter_valid_email");
    } else {
      temp.email = "";
    }

    if (!fields.password) {
      temp.password = t("enter_password");
    } else if (!/(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}/.test(fields.password) || fields.password.length < 6) {
      temp.password = t("password_rules");      
      temp.repeatpass = fields.password === fields.repeatpass ? "" : t("passwords_not_match");
    } else {
      temp.password = "";
      temp.repeatpass = fields.password === fields.repeatpass ? "" : t("passwords_not_match");
    }

    setErrors({...temp});
    return Object.values(temp).every((x) => x === "");
  };
  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setLoading(true);

    if(validateForm()){
      await dispatch(Signup(fields.email, fields.password, fields.company)).then((success: any) => {
        if(success){
          handleShowLogin();
        }
      });
    }
    setLoading(false);
  };
  const closeForm = () =>{
    setFields({company: "", email: "", password: "", repeatpass: ""});
    setErrors({company: "", email: "", password: "", repeatpass: ""});
    onHide();
  }
  return (
    <Modal size="mini" centered closeIcon open={show} onClose={closeForm}>
      <Modal.Header style={loginstyles.header}>{t("registration")}</Modal.Header>
      <Modal.Content>
        <Form onSubmit={handleSubmit} autoComplete="off">
          <Form.Field required id="new-company" autoComplete="off">
            <label>{t("company_name")}</label>
            <Form.Input id="company" type="text" name="company" value={fields.company} onChange={handleInputChange} placeholder={t("insert_company_name")} error={errors.company ? {content: errors.company, pointing: "below"} : false} />
          </Form.Field>
          <Form.Field required id="new-email" autoComplete="off">
            <label>{t("email")}</label>
            <Form.Input type="email" name="email" autoComplete="new-email" value={fields.email} onChange={handleInputChange} placeholder={t("enter_email")} error={errors.email ? {content: errors.email, pointing: "below"} : false} />
          </Form.Field>
          <Form.Field required id="new-password" autoComplete="off">
            <label>{t("password")}</label>
            <Form.Input
              id="new-password"
              type="password"
              autoComplete="new-password"
              name="password"
              value={fields.passwword}
              onChange={handleInputChange}
              placeholder={t("enter_password")}
              error={errors.password ? {content: errors.password, pointing: "below"} : false}
            />
          </Form.Field>
          <Form.Field required id="new-repeatpass" autoComplete="off">
            <label>{t("repeat_password")}</label>
            <Form.Input
              id="new-repeatpass"
              type="password"
              name="repeatpass"
              value={fields.repeatpass}
              onChange={handleInputChange}
              autoComplete="new-repeat-password"
              placeholder={t("repeat_password2")}
              error={errors.repeatpass ? {content: errors.repeatpass, pointing: "below"} : false}
            />
          </Form.Field>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Form.Button style={loginstyles.button} primary onClick={handleSubmit}>
          {t("register_btn")}
        </Form.Button>
        <div style={loginstyles.registerButton as CSSProperties} onClick={handleShowLogin}>
          {t("have_account")}
          <Form.Button style={{marginLeft: 5}} compact size="mini">
            {t("login")}
          </Form.Button>
        </div>
      </Modal.Actions>
    </Modal>
  );
};

const loginstyles = {
  header: {
    textAlign: "center",
  },
  button: {
    width: "100%",
  },
  registerButton: {
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    textAlign: "center",
    width: "100%",
    marginTop: 10,
    cursor: "pointer",
  },
};
export default Register;
